import { Space } from "melco-ui";
import MelcoAccountFlowLayout from "../../components/layout/MelcoAccountFlowLayout";
import { ValidateForm } from "../../components/validate/ValidateForm";

const Validate = () => {
  return (
    <MelcoAccountFlowLayout>
      <Space direction="vertical" size="xlarge">
        <ValidateForm />
      </Space>
    </MelcoAccountFlowLayout>
  );
};

export default Validate;
